import { PageSegmentLoadMetric } from '../metric/page-segment-load';
import { BMEventsType } from '../types';

import type { PageSegmentLoadPerformanceEventFactoryConfig } from './types';

export const pageSegmentLoad = (
	config: PageSegmentLoadPerformanceEventFactoryConfig,
): PageSegmentLoadMetric => {
	return new PageSegmentLoadMetric({
		...config,
		type: BMEventsType.PAGE_SEGMENT_LOAD,
	});
};
